import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { MenuBuilder } from "../../components/menu/MenuBuilder";

const HumanResourcePage = ({}) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));

  let menu = [
    // {auth: "THrdMonitoring", name: "Monitoring", path: "/human-resource/transaksi/monitoring"},
    {
      auth: "MKaryawan",
      name: "Karyawan",
      path: "/human-resource/transaksi/karyawan",
    },
    { auth: "TCuti", name: "Cuti", path: "/human-resource/transaksi/cuti" },
    {
      auth: "EntryCuti",
      name: "Entry Cuti",
      path: "/human-resource/transaksi/entry-cuti",
    },
    { auth: "TIzin", name: "Izin", path: "/human-resource/transaksi/izin" },
    { auth: "TSakit", name: "Sakit", path: "/human-resource/transaksi/sakit" },
    {
      auth: "TPelatihan",
      name: "Pelatihan",
      path: "/human-resource/transaksi/pelatihan",
    },
    { auth: "TTiket", name: "Tiket", path: "/human-resource/transaksi/tiket" },
    {
      auth: "TLembur",
      name: "Lembur",
      path: "/human-resource/transaksi/lembur",
    },
    {
      auth: "TPengobatan",
      name: "Claim Pengobatan",
      path: "/human-resource/transaksi/claim-pengobatan",
    },
    { auth: "TPhk", name: "PHK", path: "/human-resource/transaksi/phk" },
    {
      auth: "TResign",
      name: "Resign",
      path: "/human-resource/transaksi/resign",
    },
    {
      auth: "TPromosi",
      name: "Promosi / Mutasi",
      path: "/human-resource/transaksi/promosi",
    },
    {
      auth: "TKontrakKerja",
      name: "Kontrak Kerja",
      path: "/human-resource/transaksi/kontrak-kerja",
    },
    {
      auth: "TPerjalananDinas",
      name: "Perjalanan Dinas",
      path: "/human-resource/transaksi/perjalanan-dinas",
    },
    {
      auth: "TMonitoringLPD",
      name: "Monitoring LPD Dinas",
      path: "/human-resource/transaksi/monitoring-lpd",
    },
    {
      auth: "MTarifUangSaku",
      name: "Tarif Uang Saku",
      path: "/human-resource/transaksi/tarif-uang-saku",
    },
    { auth: "TCSR", name: "CSR", path: "/human-resource/transaksi/csr" },
    {
      auth: "TPerbaikanAbsen",
      name: "PerbaikanAbsen",
      path: "/human-resource/transaksi/perbaikan-absen",
    },
      {
      auth: "AbsensiKaryawan",
      name: "Absensi Karyawan",
      path: "/human-resource/transaksi/absensi",
    },
    {
      auth: "JamKerja",
      name: "Jadwal Kerja",
      path: "/human-resource/transaksi/jadwal-kerja",
    },
    {
      auth: "AbsensiWajah",
      name: "Enrollment Wajah",
      path: "/human-resource/transaksi/face-enrollment",
    },
    {
      auth: "KioskDevice",
      name: "Device Absensi Wajah",
      path: "/human-resource/transaksi/kiosk-device",
    },
  ];
  let Report = [
    {
      auth: "MLKaryawan",
      name: "Karyawan",
      path: "/human-resource/report/karyawan",
    },

    { auth: "TLCuti", name: "Cuti", path: "/human-resource/report/cuti" },
    { auth: "TLIzin", name: "Izin", path: "/human-resource/report/izin" },
    { auth: "TLSakit", name: "Sakit", path: "/human-resource/report/sakit" },
    {
      auth: "TLPelatihan",
      name: "Pelatihan",
      path: "/human-resource/report/pelatihan",
    },
    { auth: "TLTiket", name: "Tiket", path: "/human-resource/report/tiket" },
    { auth: "TLLembur", name: "Lembur", path: "/human-resource/report/lembur" },
    {
      auth: "TLPengobatan",
      name: "Claim Pengobatan",
      path: "/human-resource/report/claim-pengobatan",
    },
    { auth: "TLPhk", name: "PHK", path: "/human-resource/report/phk" },
    { auth: "TResign", name: "Resign", path: "/human-resource/report/resign" },
    {
      auth: "MLFKaryawan",
      name: "File Karyawan",
      path: "/human-resource/report/FileKaryawan",
    },

    // {auth: "TResign", name: "Resign", path: "resign"},
  ];
  const [listMenu, setListMenu] = useState(menu);
  const [listReport, setListReport] = useState(Report);

  const filterMenu = (event) => {
    const filtered = menu.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListMenu(filtered);
  };
  const filterReport = (event) => {
    const filtered = Report.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListReport(filtered);
  };
  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4 ">
          <MenuBuilder
            name="Transaction"
            menuController={filterMenu}
            listMenu={listMenu}
          />
          <hr className={"border border-main-100 my-6"} />
          <MenuBuilder
            name="Report"
            menuController={filterReport}
            listMenu={listReport}
          />
        </div>
      </div>
    </div>
  );
};

export default HumanResourcePage;
